import * as React from "react"
export const Svg_043 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M21.438 15.578c1.1 0 1.994-.894 1.994-1.994v-1.03c0-1.1-.894-1.994-1.994-1.994s-1.994.895-1.994 1.995v1.029c0 1.1.894 1.994 1.994 1.994Z"
    />
    <path
      fill="url(#b)"
      d="M16.835 21.521v.982h9.206v-.982a2.488 2.488 0 0 0-2.485-2.485H19.32a2.488 2.488 0 0 0-2.485 2.485Z"
    />
    <path
      fill="url(#c)"
      d="M6.462 0v59h46.076V0H6.462Zm6.915 21.521a5.95 5.95 0 0 1 3.283-5.314 5.42 5.42 0 0 1-.674-2.623v-1.03a5.458 5.458 0 0 1 5.452-5.452 5.458 5.458 0 0 1 5.452 5.453v1.029c0 .95-.244 1.845-.674 2.623a5.95 5.95 0 0 1 3.283 5.314v4.44H13.377v-4.44Zm5.534 27.602h-3.458v-3.458h3.458v3.458Zm0-6.916h-3.458V38.75h3.458v3.458Zm0-6.916h-3.458v-3.458h3.458v3.458Zm24.636 13.832H22.37v-3.458h21.178v3.458Zm0-6.916H22.37V38.75h21.178v3.458Zm0-6.916H22.37v-3.458h21.178v3.458Zm0-9.33h-9.785v-3.458h9.785v3.458Zm0-6.916h-9.785v-3.458h9.785v3.458Zm0-6.917h-9.785V8.672h9.785v3.458Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={20.366}
        x2={22.949}
        y1={11.313}
        y2={14.636}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={18.964}
        x2={19.777}
        y1={19.556}
        y2={23.05}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={17.117}
        x2={47.613}
        y1={8.85}
        y2={47.394}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)